import {request} from './request';
const BASE = '/admin'
// 打印测试
export const print_pda = (data) => {
    return request(`/distribution/print_pda`,"post",data)
}